module.exports = __webpack_public_path__ + "img/popup-bg-1.bf3a4a1.png";